export default __webpack_public_path__ + "static/media/chart-02.5eaf94d1.svg";